import React, {useEffect, useState} from 'react';
import axios from "axios";
import {addFunc, bolFunc, fixIt} from "../../../../../../../../components/functions/Mathematik";
import {user_data} from "../../../../../../../../components/functions/usr";
import decade_days, {gmslar, season_month} from "../../../../../../../../components/sfr/maydon";
import {header} from "../../../../../../../../components/api/Header";
import { getEnv } from "../../../../../../../../lib/env";

function Limit3() {

    const lkoifsent = localStorage.getItem('sfr-hm-veg-koifsent') ? localStorage.getItem('sfr-hm-veg-koifsent') : 1
    const user = user_data()
    const year = localStorage.getItem('sfr-hm-year') ? localStorage.getItem('sfr-hm-year') : new Date().getFullYear()
    const manba = localStorage.getItem("sfr-hm-manbalar")
    const manbalar = manba ? JSON.parse(manba) : []
    const ist = localStorage.getItem("sfr-hm-istemolchilar")
    const istemolchilar = ist ? JSON.parse(ist) : []
    const [swed, setSwed] = useState({})
    const ekin = localStorage.getItem("sfr-hm-veg-ekinlar")
    const ekinlar = ekin ? JSON.parse(ekin) : {}
    const ste1 = localStorage.getItem("sfr-hm-ste")
    const ste = ste1 ? JSON.parse(ste1) : {}
    const sfrMaydon = localStorage.getItem("sfr-hm-veg-maydon")
    const sfrMaydonlar = sfrMaydon ? JSON.parse(sfrMaydon) : {}
    const [maydonlar, setMaydonlar] = useState({})
    const daysindek = decade_days('veg', year)
    const cropid = localStorage.getItem('sfr-hm-veg-ekinids')
    const cropids = cropid ? JSON.parse(cropid) : []


    useEffect(() => {
        let gmss = []
        const fetchSwed = async (gmss, gmss2) => {
            const postData = {
                crops: cropids,
                gmss,
                maydonlar: gmss2,
                tomorqa1: false
            }
            const res = await axios.post(
                getEnv('REACT_APP_BASE_URL') + "/v1/district/sfrmain/veg_sugorish_meyyori2",
                postData,
                header()
            )
                .catch(e => {
                    console.log("Xato", e)
                })
            if (res) {
                setSwed(res.data)
            }
        }
        const maydon = () => {
            let gidromodullar = []
            istemolchilar.map(i => {
                if (i.gms) {
                    i.gms.map(g => {
                        if (!gidromodullar.includes(g)) {
                            gidromodullar.push(g)
                        }
                    })
                }
            })
            gmss = gidromodullar
        }
        maydon()
        const gmss2 = gmslar(sfrMaydonlar, cropids)
        setMaydonlar(gmss2)
        if (gmss2)
            fetchSwed(gmss, gmss2)
    }, [])
    const ff = (ist, fik) => {
        if (!ist.gms) return 0
        if (!ist.gms.length) return 0
        let res = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (let deks = 1; deks < 19; deks++) {
            let bm = 0
            let jbm = 0
            Object.keys(ekinlar).map(e => {
                let nm = 0
                let jnm = 0
                if (swed[e.slice(1)]) {
                    ist.gms.map(gms2 => {
                        if (swed[e.slice(1)][gms2]) {
                            let jm = maydonlar['g' + gms2] ? maydonlar['g' + gms2][e] : 0
                            let im = sfrMaydonlar['i' + ist.id] ? sfrMaydonlar['i' + ist.id]['g' + gms2] ? sfrMaydonlar['i' + ist.id]['g' + gms2][e] : 0 : 0
                            let ds = swed[e.slice(1)][gms2][deks] * 1 / 0.0864 / daysindek['d' + deks]
                            let jds = swed[e.slice(1)][gms2][deks]
                            nm = addFunc(nm, (bolFunc(im, jm) * ds))
                            jnm = addFunc(jnm, (bolFunc(im, jm) * jds))
                        }
                    })
                    bm = addFunc(bm, bolFunc(nm, fik))
                    jbm = addFunc(jbm, bolFunc(jnm, fik))
                }
            })
            res[deks] = bm > 0 ? bm : 0
            res[0] = addFunc(res[0], jbm > 0 ? jbm : 0)
        }
        return res
    }
    const xisobot = () => {
        if (manbalar.length) {
            let obj = [];
            let tr = 1
            if (istemolchilar.length) {
                istemolchilar.map(ist => {
                    let ms = ff(ist, ist.fik)
                    obj.push(
                        <tr key={ist.name + "a"}>
                            <td>{tr++}</td>
                            <td className="text-start">{ist.name}</td>
                            {
                                ms.length ?
                                    ms.map((m, mi) => {
                                        return <td key={mi}>{(m*lkoifsent)?fixIt(m * lkoifsent):''}</td>
                                    })
                                    : null
                            }
                        </tr>
                    )
                })
            }

            return obj;
        }
    }
    return (


        <div className="row">
            <div className="col-12">
                <table className="table table-borderless">
                    <thead>
                    <tr>
                        <td colSpan={21}><h3 className="text-center">Limit - №3</h3></td>
                    </tr>
                    <tr>
                        <td colSpan={21}>
                            <h4 className="text-center">
                                {user.district} bo'yicha {year} - yil sug'orish davrida suv manbalaridan olinadigan cheklangan suv miqdori (limit)
                            </h4>
                        </td>
                    </tr>
                    </thead>
                </table>
                <div className="text-end pe-4">l/sek</div>
                <div className="flex-box">
                    <div className="xisobotTable">
                        <table className="table table-bordered text-center xisobot3">
                            <thead className="sticky-top" style={{background: "#77adba", color: "#fff"}}>
                            <tr>
                                <th rowSpan={2} className="vertical-middle">No</th>
                                <th rowSpan={2} style={{minWidth: "150px"}} className="vertical-middle">Istemolchi nomi</th>
                                <th rowSpan={2} className="vertical-middle">Suv hajmi ming.m<sup>3</sup></th>
                                {
                                    season_month('veg').map((m, i) => {
                                        return <th key={i} colSpan={3}>{m}</th>
                                    })
                                }
                            </tr>
                            <tr>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                            </tr>
                            </thead>
                            <tbody>
                            {xisobot()}
                            </tbody>

                        </table>

                    </div>
                </div>

            </div>
        </div>
    );
}

export default Limit3;